import w from "react";
import { cls as v } from "../../helpers/cls.js";
var y = Object.defineProperty,
  t = Object.getOwnPropertySymbols,
  c = Object.prototype.hasOwnProperty,
  d = Object.prototype.propertyIsEnumerable,
  s = (o, e, r) => e in o ? y(o, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : o[e] = r,
  n = (o, e) => {
    for (var r in e || (e = {})) c.call(e, r) && s(o, r, e[r]);
    if (t) for (var r of t(e)) d.call(e, r) && s(o, r, e[r]);
    return o;
  },
  O = (o, e) => {
    var r = {};
    for (var a in o) c.call(o, a) && e.indexOf(a) < 0 && (r[a] = o[a]);
    if (o != null && t) for (var a of t(o)) e.indexOf(a) < 0 && d.call(o, a) && (r[a] = o[a]);
    return r;
  };
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const p = o => {
  var e = o,
    {
      dsParentName: r,
      color: a = "info",
      size: b = "small",
      shape: m = "rectangle",
      className: u,
      customColor: l,
      withoutColumnGap: f,
      withWhiteBorder: g,
      style: _ = {}
    } = e,
    i = O(e, ["dsParentName", "color", "size", "shape", "className", "customColor", "withoutColumnGap", "withWhiteBorder", "style"]);
  return w.createElement("span", n({
    "data-ds-component": r ? "DS-".concat(r, "-Badge") : "DS-Badge",
    className: v({
      "olx-badge": !0,
      ["olx-badge--".concat(a)]: !0,
      ["olx-badge--".concat(b)]: !0,
      ["olx-badge--".concat(m)]: !0,
      "olx-badge--white-border": g,
      "olx-badge--no-gap": f
    }, u),
    style: n(n({}, l ? {
      "--badge-color": l == null ? void 0 : l.textColor,
      "--badge-background-color": l == null ? void 0 : l.backgroundColor
    } : {}), _)
  }, i), i.children);
};
p.displayName = "Badge";
export { p as Badge };